import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";
import { AUformGroup } from '@gov.au/form';
import moment from 'moment';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import { getFormServiceStatusSelector } from '../../FormStore/Selectors/FormDataSelectors';
import { addPageAlert } from '../../PortalStore/Actions/PageAlertActions';
import { getAdditionalPaymentSubmissions } from '../../FormStore/Actions/FormServiceActions/RequestPayment/GetAdditionalPaymentSubmissionsAction';
import { getOrganisationDetails, FETCH_ORGANISATIONDETAILS_SUCCESS } from '../../PortalStore/Actions/OrganisationDetailsActions';

import Heading from '../../components/CASA/Heading';
import CASASpinner from '../../components/Portal/CASASpinner';
import { SimpleItemSummary } from '../../components/CASAForm/CustomComponents/SimpleItemSummary';

const buildSubmissonTableBody = (submissions) => submissions.map(submission => {
    return (
        {
            id: submission.submissionId,
            application: submission.portalName,
            dueDate: moment(submission.expiryDate, "YYYY-MM-DDTHH:mm:ssZ", true).format("DD MMM YYYY"),
            fee: submission.totalAmountDue.toLocaleString('en-AU', {
                style: 'currency',
                currency: 'AUD',
            })
        }
    )
})

const AdditionalPaymentPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [loaderActive, setLoaderActive] = useState(true);
    const [orgLoaded, setOrgLoaded] = useState(false);

    const { organisationId } = useParams();
    const B2CSettings = useSelector(state => state.B2CSettings.items);
    const submissionDetails = useSelector(state => getFormServiceStatusSelector(state.formStore, 'getAdditionalPaymentSubmissions'));
    const organisationDetails = useSelector(state => state.organisationDetails);

    const tableHeader = [
        // eslint-disable-next-line react/display-name
        { title: "Description", key: "application", width: "50", render: (text, selectedRow) => <button onClick={() => redirectToPaymentForm(selectedRow)} className="faux-link">{text}</button> },
        { title: "Payment due", key: "dueDate", width: "10" },
        { title: "Fee", key: "fee", width: "10" }
    ];

    useEffect(() => {
        const webappurl = B2CSettings.webappurlPortalApi;
        const accessToken = B2CSettings.accesstokenPortal;

        axios.all([
            dispatch(getOrganisationDetails(webappurl, accessToken, organisationId)),
            
        ])
            .then(axios.spread((orgdetailsres) => {
                if (orgdetailsres.type === FETCH_ORGANISATIONDETAILS_SUCCESS
                ) {
                    setOrgLoaded(true);
                }
                else {
                    setLoaderActive(false);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: APO.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setLoaderActive(false);

                dispatch(addPageAlert({ level: "error", title: "System error APO.1" }));
            });

    }, []);

    // Query submission details
    useEffect(() => {
        if (orgLoaded) {
            debugger; // eslint-disable-line no-debugger
            const accountId = organisationId ? organisationDetails?.items?.value[0].accountid : null;
            const orgArn =  organisationId ? organisationDetails?.items?.value[0].casa_arn : null;
            dispatch(getAdditionalPaymentSubmissions(
                B2CSettings.webappurlFormsApi,
                B2CSettings.accesstokenForms,
                accountId,
                orgArn
            ));
        }
    }, [orgLoaded]);

    // Handle successful response from get Submission Details service
    useEffect(() => {
        if (submissionDetails.wasSuccessful) {
            setLoaderActive(false);
            let submissionTablePayload = buildSubmissonTableBody(submissionDetails.data);
            if (submissionTablePayload?.length === 1) {
                redirectToPaymentForm(submissionTablePayload[0]);
            }
        }
        else if (submissionDetails.errors) {
            // TODO: This error message doesn't make sense
            dispatch(addPageAlert({
                level: "error",
                title: "Unable to complete application online",
                message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
            }));
            setLoaderActive(false);
        }
    }, [submissionDetails]);

    const redirectToPaymentForm = (selectedRow) => {
        if (organisationDetails.items.value && organisationId) {
            history.push(`/organisation/${organisationDetails.items.value[0].accountid}/submissions/${selectedRow.id}/payment`)
        }
        else {
            history.push(`/submissions/${selectedRow.id}/payment`)
        }
    }

    return (

        <>
            {loaderActive ? <CASASpinner /> :
                <>
                    <Heading
                        text="Payment request"
                        breadcrumbs={[
                            { text: 'myCASA', link: organisationDetails?.items?.value[0] ? '/dashorg/?casaorgid=' + organisationDetails.items.value[0] : '/dashind' },
                            { text: 'Payment request' }
                        ]}
                        showback />

                    {submissionDetails.wasSuccessful &&
                        <>
                            <h2>Payment items</h2>

                            <AUformGroup>
                                <SimpleItemSummary
                                    caption="Please select a payment item"
                                    tableHeader={tableHeader}
                                    tableBody={buildSubmissonTableBody(submissionDetails.data)} />

                            </AUformGroup>
                        </>
                    }
                </>
            }
        </>
    );
};

AdditionalPaymentPage.propTypes = {
    dispatch: PropTypes.func,
    B2CSettings: PropTypes.object,
    envdata: PropTypes.object,
    previousPageLink: PropTypes.string,
    formProperties: PropTypes.object,
    verificationViewData: PropTypes.object,
    match: PropTypes.object
};

export default AdditionalPaymentPage;